import { createGlobalStyle } from "styled-components";

interface StylesProps {
  theme: {
    text: string;
    background: string;
  };
}

const GlobalStyle = createGlobalStyle<StylesProps>`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {    
    color: ${(props) => props.theme.text};
    background: ${(props) => props.theme.background};
    transition: all 0.25s;
    font-family: "Big Shoulders Stencil Text", Arial, Helvetica, sans-serif;
    font-size: 1rem;
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }

  h1, h2, h3, h4, h5, h6, p, span, button {
    font-family: "Big Shoulders Stencil Text", Arial, Helvetica, sans-serif;
    font-size: 1rem;
    font-weight: 500;
  }
`;

export default GlobalStyle;
